import React from 'react';
import './Contact.css'
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import { FaClock } from "react-icons/fa";


const Contact = () => {

    return (
        <>


<section id="contact" class="contact">

<div class="container" data-aos="fade-up">

  <header class="section-header">
    <h2>Contact</h2>
    <p>Contact Us</p>
  </header>

  <div class="row">

    <div class="col-lg-6">

      <div class="row">
        <div class="col-md-6 py-4">
          <div class="info-box">
          <i class="fa-solid fa-location-dot">
            <FaMapMarkerAlt/>
          </i>
            <h3>Address</h3>
            <p>Afienya, Mataheko<br/>adjacent MF Police Station</p>
          </div>
        </div>
        <div class="col-md-6 py-4">
          <div class="info-box">
          <i class="fa-solid fa-phone">
            <FaPhoneAlt/>
          </i>
            <h3>Call Us</h3>
            <p>+233 54 824 2072<br/>+233 00 200 5006</p>
          </div>
        </div>
        <div class="col-md-6 py-4">
          <div class="info-box">
          <i class="fa-regular fa-envelope">
            <FaEnvelope/>
          </i>
            <h3>Email Us</h3>
            <p>info.smarttechacademy.com<br/>smarttechacademy@gmail.com</p>
          </div>
        </div>
        <div class="col-md-6 py-4">
          <div class="info-box">
          <i class="fa-regular fa-clock">
            <FaClock/>
          </i>
            <h3>Open Hours</h3>
            <p>Monday - Saturday<br/>9:00AM - 05:00PM</p>
          </div>
        </div>
      </div>

    </div>

    <div class="col-lg-6 py-4">
      <form action="forms/contact.php" method="post" class="php-email-form">
        <div class="row gy-4">

          <div class="col-md-6">
            <input type="text" name="name" class="form-control" placeholder="Your Name" required />
          </div>

          <div class="col-md-6 ">
            <input type="email" class="form-control" name="email" placeholder="Your Email" required />
          </div>

          <div class="col-md-12">
            <input type="text" class="form-control" name="subject" placeholder="Subject" required />
          </div>

          <div class="col-md-12">
            <textarea class="form-control" name="message" rows="6" placeholder="Message" required></textarea>
          </div>

          <div class="col-md-12 text-center">
            <div class="loading">Loading</div>
            <div class="error-message"></div>
            <div class="sent-message">Your message has been sent. Thank you!</div>

            <button type="submit">Send Message</button>
          </div>

        </div>
      </form>

    </div>

  </div>

</div>

</section>


        </>
    );

}

export default Contact;